"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DuskLaserMining = void 0;
const CardName_1 = require("../../CardName");
const CardType_1 = require("../CardType");
const Tags_1 = require("../Tags");
const Resources_1 = require("../../Resources");
const CardRequirements_1 = require("../CardRequirements");
const CardRenderer_1 = require("../render/CardRenderer");
const Card_1 = require("../Card");
class DuskLaserMining extends Card_1.Card {
    constructor() {
        super({
            cardType: CardType_1.CardType.AUTOMATED,
            name: CardName_1.CardName.DUSK_LASER_MINING,
            cost: 8,
            tags: [Tags_1.Tags.SPACE],
            requirements: CardRequirements_1.CardRequirements.builder((b) => b.tag(Tags_1.Tags.SCIENCE, 2)),
            metadata: {
                cardNumber: 'X01',
                description: 'Requires 2 Science tags. Decrease your energy production 1 step, and increase your titanium production 1 step. Gain 4 titanium.',
                renderData: CardRenderer_1.CardRenderer.builder((b) => {
                    b.production((pb) => {
                        pb.minus().energy(1).br;
                        pb.plus().titanium(1);
                    }).nbsp().titanium(4).digit;
                }),
            },
        });
    }
    canPlay(player) {
        return super.canPlay(player) && player.getProduction(Resources_1.Resources.ENERGY) >= 1;
    }
    play(player) {
        player.addProduction(Resources_1.Resources.ENERGY, -1);
        player.addProduction(Resources_1.Resources.TITANIUM, 1);
        player.titanium += 4;
        return undefined;
    }
}
exports.DuskLaserMining = DuskLaserMining;
//# sourceMappingURL=DuskLaserMining.js.map